import { render, staticRenderFns } from "./SuiviBagages.vue?vue&type=template&id=2afbecb4&scoped=true"
import script from "./SuiviBagages.vue?vue&type=script&lang=js"
export * from "./SuiviBagages.vue?vue&type=script&lang=js"
import style0 from "./SuiviBagages.vue?vue&type=style&index=0&id=2afbecb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afbecb4",
  null
  
)

export default component.exports